/**
 * 获取这个月的第一天
 * @returns {string}
 */
function getCurrentMonthFirst() {
  var date = new Date();
  date.setDate(1);
  var seperator1 = '-';
  var year = date.getFullYear();
  var month = date.getMonth() + 1;
  var strDate = date.getDate();
  if (month >= 1 && month <= 9) {
    month = '0' + month;
  }
  if (strDate >= 0 && strDate <= 9) {
    strDate = '0' + strDate;
  }
  var currentdate = year + seperator1 + month + seperator1 + strDate;
  return currentdate;
}

/**
 * 获取当前时间
 * @returns {string}
 */
function getNowFormatDate() {
  var date = new Date();
  var seperator1 = '-';
  var year = date.getFullYear();
  var month = date.getMonth() + 1;
  var strDate = date.getDate();
  if (month >= 1 && month <= 9) {
    month = '0' + month;
  }
  if (strDate >= 0 && strDate <= 9) {
    strDate = '0' + strDate;
  }
  var currentdate = year + seperator1 + month + seperator1 + strDate;
  return currentdate;
}

function getCurrentMonthFirstDate() {
  var date = new Date();
  date.setDate(1);
  return date;
}

export {getCurrentMonthFirst, getNowFormatDate, getCurrentMonthFirstDate};
